const tab_1 = document.querySelector(".custom-guide__tabs__nav-item[data-tab='1']");
const tab_2 = document.querySelector(".custom-guide__tabs__nav-item[data-tab='2']");
const tab_3 = document.querySelector(".custom-guide__tabs__nav-item[data-tab='3']");

const switch_tab = (e) => {
    if(e.target.classList.contains("active")) return;
    const tab_id = e.target.getAttribute("data-tab");
    document.querySelectorAll(".custom-guide__tabs__nav-item").forEach(item => {
        item.classList.remove("active");
        if(item.getAttribute("data-tab") == tab_id) item.classList.add("active");
    });
    document.querySelectorAll(".custom-guide__tab").forEach(item => {
        item.classList.remove("active");
        if(item.classList.contains(`custom-guide__tab--${tab_id}`)) item.classList.add("active");
    });
}

tab_1.addEventListener("click", switch_tab);
tab_2.addEventListener("click", switch_tab);
tab_3.addEventListener("click", switch_tab);